import React from 'react'
import SvgCollapse from '#/assets/images/icons/expand_less.svg'
import SvgExpand from '#/assets/images/icons/expand_more.svg'
import { logEvent } from '#/services/analytics'
import cn from '#/utils/classnames'
import styles from './styles.module.scss'

export type FAQItem = {
  question: string
  answer: React.ReactNode
}

type Props = {
  className?: string
  classes?: {
    root?: string
    question?: string
    toggle?: string
    answer?: string
    item?: string
    itemExpanded?: string
  }
  items: FAQItem[]
  noTitle?: boolean
}

export default function FAQ({ className, classes, items, noTitle }: Props) {
  const [current, setCurrent] = React.useState(0)

  function handleClickQuestion(item: FAQItem, index: number) {
    setCurrent(current === index ? -1 : index)

    logEvent('select_content', {
      content_type: 'faq',
      item_id: 'open_faq',
      question_id: index,
      question_text: item.question?.toString(),
      type: 'faq_click',
      items: [
        {
          item_id: index,
          item_name: item.question?.toString()
        }
      ]
    })
  }

  return (
    <div className={cn(styles['th-faq'], className, classes?.root)}>
      {!noTitle && (
        <div className={styles['th-faq-title']}>Frequently asked questions</div>
      )}
      {items.map((e, index) => (
        <div
          key={index}
          className={cn(
            styles['th-faq-item'],
            classes?.item,
            index === current && classes?.itemExpanded,
            { [styles['th-expanded']]: index === current }
          )}
        >
          <div
            className={cn(styles['th-faq-question'], classes?.question)}
            onClick={() => handleClickQuestion(e, index)}
          >
            {e.question}
            {current === index ? (
              <SvgCollapse className={cn(styles['th-faq-question-toggle'], classes?.toggle)} />
            ) : (
              <SvgExpand className={cn(styles['th-faq-question-toggle'], classes?.toggle)} />
            )}
          </div>
          <div className={cn(styles['th-faq-answer'], classes?.answer)}>{e.answer}</div>
        </div>
      ))}
    </div>
  )
}
